module.exports = __webpack_public_path__ + "img/football.f2c23c33.png";